//actions de la home
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_BY_NAME = " GET_PRODUCTS_BY_NAME"; 
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
export const GET_CATEGORY = "GET_CATEGORY"
export const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
export const GET_BRAND= "GET_BRAND";
export const FILTER_BY_BRAND = "FILTER_BY_BRAND";
export const GET_SIZE= "GET_SIZE";
export const FILTER_BY_SIZE = "FILTER_BY_SIZE";
export const GET_PRICE="GET_PRICE"
export const PRICE_RANGE_SELECTOR="PRICE_RANGE_SELECTOR"
export const ORDER_BY_PRICE = "ORDER_BY_PRICE";
export const GET_PUNCTUATION= "GET_PUNCTUATION";
export const POST_PUNCTUATION= "POST_PUNCTUATION";
export const ORDER_BY_BEST_RATING= "ORDER_BY_BEST_RATING";
export const ORDER_BY_BEST_SELLING="ORDER_BY_BEST_SELLING"
export const GET_STOCK="GET STOCK"
export const PUT_STOCK="PUT_STOCK"
//actions del footer
export const POST_NEWSLETTER="POST_NEWSLETTER";
export const GET_NEWSLETTER="GET_NEWSLETTER";
export const REGISTRO_NEWSLETTER = "REGISTRO_NEWSLETTER"
//acciones del detail 
export const ADD_QUANTITY="ADD_QUANTITY";
export const ADD_SIZE="ADD SIZE";
export const ADD_TO_CART="ADD_TO_CART";
export const GET_CART_BY_ID='GET_CART_BY_ID';
//acccion Favoritos
export const GET_USERS_FAVORITES="GET_USERS_FAVORITES";
export const ADD_FAV="ADD_FAV";
export const DELETE_FAV="DELETE_FAV";
export const DELETE_CART="DELETE_CART";
//acciones del carrito
export const CHANGE_PRODUCT="CHANGE_PRODUCT";
export const BUY="BUY";
export const DELETE_PRODUCT_CART="DELETE_PRODUCT_CART";
export const UPDATE_PRODUCT_CART="UPDATE_PRODUCT_CART";
//acciones del usuario
export const LOG_IN="LOG_IN";
export const GET_USERS="GET_USERS";
export const POST_USER_SUCCESS="POST_USER_SUCCESS";
export const UPDATE_USER_FAILURE="UPDATE_USER_FAILURE";
export const POST_INGRESO = "POST_INFRESO";
export const BORRAR_TOKEN = "BORRAR_TOKEN";
export const POST_REGISTRO = "POST_REGISTRO";
export const POST_GOOGLE = "POST_GOOGLE";
export const CLOSE_SESSION = "CLOSE_SESSION";
export const POST_MERCADO_PAGO = "POST_MERCADO_PAGO";
export const GET_MERCADO_PAGO = "GET_MERCADO_PAGO";
export const GET_DATOS_USER = "GET_DATOS_USER";
export const PUT_ROL_USER = "PUT_ROL_USER";
export const PUT_STATE_USER = "PUT_STATE_USER";
export const GET_ORDEN_DE_COMPRA="GET_ORDEN_DE_COMPRA";
//acciones del administrador
export const GET_USER_DETAIL=" GET_USER_DETAIL"
export const GET_USER_BY_NAME="GET_USER_BY_NAME"
export const PUT_USER="PUT_USER"
export const GET_PRODUCT_DETAIL_ADMIN = "GET_PRODUCT_DETAIL_ADMIN";
export const PUT_PRODUCT_PRICE="PUT_PRODUCT_PRICE"
export const PUT_PRODUCT_IMAGE="PUT_PRODUCT_IMAGE"
export const PUT_PRODUCT_STOCK="PUT_PRODUCT_STOCK"
export const GET_SALES="GET_SALES"
export const POST_USER_ADMIN="POST_USER_ADMIN"

//accion orden de compra
export const POST_ORDEN = "POST_ORDEN";
export const GET_ORDEN_USER = "GET_ORDEN_USER"
//accion promotions
export const POST_PROMOTIONS = "POST_PROMOTIONS"
export const GET_PROMOTIONS = "GET_PROMOTIONS"
export const PUT_PROMO_CURRENT = "PUT_PROMO_CURRENT"